import AppSettings from './AppSettings'; // callback onError

// Add Common methods here
export default class GlobalSettings {
    constructor() { }

    // Get query string
    getQueryString(field, url) {
        const href = url ? url : window.location.href;
        const reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
        const string = reg.exec(href);
        return string ? string[1] : null;
    };

    // remove specific class
    removeClassByPrefix(el, prefix) {
        const regx = new RegExp('\\b' + prefix + '.*?\\b', 'g');
        el.className = el.className.replace(regx, '');
        return el;
    }

    // HANDOVER KEY HANDLING BY URL - (rootdomain/index.html?hkey=your_handoverkey)
    handoverKeyByURL() {
        const hkey = this.getQueryString('hkey');

        const currentHkey = document.getElementById("aam-designer").getAttribute("data-handoverkey");
        // if hkey is there in url replace with default handover key
        if (hkey) {
            document.getElementById("aam-designer").setAttribute("data-handoverkey", hkey);
        } else {
            if(currentHkey)console.log('%cRunning with default handoverkey : ', 'font-size: 14px; color:green', currentHkey)
            else alert("Error: No handover key has been assigned to the aam-designer.");
        }
    }

    // Theme Handling - eg. Theme=private-banking
    themeHandling() {
        const theme = this.getQueryString('Theme');
        const aamDesigner = document.getElementById("aam-designer");
        switch(theme) {
            case 'private-banking' :
            aamDesigner.classList.add(theme);
            break;
            case 'Private-Banking' :
            aamDesigner.classList.add('private-banking');
            break;
            case 'high-contrast' :
            aamDesigner.classList.add(theme);
            break;
            case 'High-Contrast' :
            aamDesigner.classList.add('high-contrast');
            break;
        }
    }

    // Language Handling By URL - (/index.html?languageId=fr-FR)
    langIdByURL() {
        const languageIdKey = 'languageId';
        return this.getQueryString(languageIdKey);
    }

    classManagementForHeader(currentView, currentTitle = '') {
        // adding class for view specific
        const topWrapper = document.querySelector('.aam-designer-init');
        this.removeClassByPrefix(topWrapper,'landing-page-wrapper');
        this.removeClassByPrefix(topWrapper,'gallery-page-wrapper');
        this.removeClassByPrefix(topWrapper,'designer-page-wrapper');
        this.removeClassByPrefix(topWrapper,'preview-page-wrapper');
        this.removeClassByPrefix(topWrapper,'error-page-wrapper');
        this.removeClassByPrefix(topWrapper,'gallery-flow-wrapper');
        
        topWrapper.classList.add(currentView+'-wrapper');
        
        // View specific title
        const navTitle = document.querySelector('.aam-designer-init .toolbar .title-section');
        navTitle.innerHTML = currentTitle;
    }

    addClass(selector, className) {
        selector.classList.add(className);
    }
}


// Generic SET local storage
export function setLocalStorage(key, value) {
	if(window.localStorage) {
        window.localStorage.setItem(key,value);
    } else {
        alert('Your browser does not support localStorage, Please upgrade now');
    }
}

// Generic REMOVE local storage
export function removeLocalStorage(key) {
    if(window.localStorage){
        window.localStorage.removeItem(key);
    } else {
        alert('Your browser does not support localStorage, Please upgrade now');
    }
}

// Generic callbackOnError method - higher priority
export function getCallbackOnError(e) {
   if(AppSettings.instanceSettings.callbacks && AppSettings.instanceSettings.callbacks.onError) {
		AppSettings.instanceSettings.callbacks.onError(e);
    }
}

// --------- generic DOM Manipulation -------- //
// string to html
export function stringToHTML(str) {
    let html;
    const dom = document.createElement("div");
    dom.innerHTML = str;
    html = dom.innerHTML;
    return html;
  }
  // --------- generic DOM Manipulation -------- //